import React, {useCallback} from 'react';

import {InnerAriaMenuButton} from './InnerAriaMenuButton';
import type {AriaMenuProps} from './AriaMenu.types';
import {ariaMenuOpenStateSignal} from './AriaMenu.signals';

/**
 * AriaMenu component represents a dropdown menu. Menu items can open submenus in
 * place, rendering either a nested list of items or arbitrary React content,
 * with a back button to return to the previous level.
 */
export const AriaMenu: React.FC<AriaMenuProps> = ({
    items,
    button,
    renderButton,
    headerContent,
    onOpenChange: onOpenChangeProp,
    testId,
    colorScheme,
    popoverPlacement,
    popoverOffset,
    menuClassName,
    itemClassName,
    backButtonLabel,
    onGoBack,
    showSubMenuIndicator,
}) => {
    const onOpenChange = useCallback(
        (isOpen: boolean) => {
            ariaMenuOpenStateSignal.emit(isOpen);
            onOpenChangeProp?.(isOpen);
        },
        [onOpenChangeProp],
    );

    return (
        <InnerAriaMenuButton
            items={items}
            button={button}
            renderButton={renderButton}
            headerContent={headerContent}
            onOpenChange={onOpenChange}
            testId={testId}
            colorScheme={colorScheme}
            popoverPlacement={popoverPlacement}
            popoverOffset={popoverOffset}
            menuClassName={menuClassName}
            itemClassName={itemClassName}
            backButtonLabel={backButtonLabel}
            onGoBack={onGoBack}
            showSubMenuIndicator={showSubMenuIndicator}
        />
    );
};
